import styled from '@emotion/styled'
import styles, { typo } from '@mathflat/common/style'

const {
  colors: { borderColor, gray, blue, red },
} = styles

export const S = {
  Modal: styled.div`
    width: 650px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    .modal-header {
      padding: 24px;
      border-bottom: 1px solid ${borderColor};
      ${typo.heading05};
      font-weight: 700;
      color: ${gray.$900};
    }
    .modal-body {
      overflow-y: auto;
      overflow-x: hidden;
      max-height: 500px;
      padding: 32px 24px;
      text-align: center;

      .modal-body-header {
        width: 600px;
        margin-bottom: 40px;
        h2 {
          ${typo.heading03};
          font-weight: 700;
          margin-bottom: 4px;
        }
        strong {
          ${typo.body02};
          font-weight: 400;
        }
      }
      .modal-step-wrapper {
        display: flex;
        justify-content: center;
        gap: 10px;
        width: 600px;
        margin-bottom: 32px;
      }
      .modal-step {
        overflow: hidden;
        border-radius: var(--Radius-Circle);
        width: 10px;
        height: 10px;
        color: transparent;
        background-color: ${blue.$100};
        &.active {
          background-color: ${blue.$300};
        }
      }
    }
    .error-message {
      margin-top: 4px;
      color: ${red.$400};
      ${typo.caption01};
      &.align-right {
        text-align: right;
      }
    }
  `,
  ModalContent: styled.section`
    width: 600px;
    overflow: hidden;
    border-radius: var(--Radius-200);
    border: 1px solid ${gray.$300};
    text-align: left;
    & + * {
      margin-top: 8px;
    }
    &:not(.open) .step-content {
      display: none;
    }
    &:not(.active) .step-header-title {
      color: ${gray.$500};
    }
    &:not(.active) .step-badges {
      color: ${gray.$500};
    }
    .step-header {
      width: 600px;
      padding: 16px 24px;
      background: ${gray.$100};
      display: flex;
      gap: 8px;
      align-items: center;
      div > {
        label {
          display: flex;
          justify-content: start;
        }
      }
    }
    .step-header-title {
      height: 20px;
      ${typo.body01};
      font-weight: 700;
    }
    .step-content {
      width: 600px;
      padding: 16px 24px;
      border-top: 1px solid ${gray.$300};
      h4 {
        ${typo.body02};
        font-weight: 700;
      }
    }
    .terms {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 4px;
      + .terms {
        margin-top: 12px;
      }
      label {
        color: ${gray.$700};
        ${typo.body02};
      }
    }
    .contract-pdf-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .signature-content > div {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .signature-content + .signature-content {
      margin-top: 12px;
    }
  `,
  ModalInfoContent: styled.section`
    width: 600px;
    display: flex;
    padding: 24px;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    border-radius: var(--Radius-200);
    border: 1px solid ${gray.$300};
    background: ${gray.$100};
    ${typo.body02};
    font-weight: 700;
    .step-header {
      color: ${red.$400};
    }
    .step-content {
      ${typo.body02};
      color: ${gray.$700};
      font-weight: 400;
      text-align: left;
    }
    b {
      font-weight: 700;
    }
  `,
  ModalStep3: styled.section`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 24px;
    width: 494px;
    padding: 24px;
    text-align: center;
    strong {
      ${typo.body02};
      font-weight: 400;
    }
    p {
      ${typo.caption01};
      font-weight: 400;
      color: ${gray.$700};
    }
    .button-wrap {
      display: flex;
      gap: 8px;
      justify-content: center;
    }
  `,
  Footer: styled.footer`
    display: flex;
    gap: 12px;
    justify-content: flex-end;
    padding: 16px 24px 24px;
    border-top: 1px solid ${borderColor};
    &.contract-footer {
      .error-message {
        margin-top: 0;
        ${typo.body02};
        color: ${red.$400};
        text-align: right;
      }
    }
  `,
}
